import { useGetPcscReadersQuery } from '@/core/services/dmp-connect-js2'
import { useMemo } from 'react'

export function useGetVitaleCards() {
  const { readers, isLoading, refetch } = useGetPcscReadersQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => ({ isLoading, readers: data?.Readers }),
  })

  const vitaleCardReaders = useMemo(() => readers?.filter((reader) => reader.i_slotType === 2) ?? [], [readers])

  const vitaleCards = useMemo(
    () =>
      vitaleCardReaders.map((reader) => ({
        label: `${reader.s_name} (${reader.s_slotType})`,
        value: reader.s_name,
      })) ?? [],
    [vitaleCardReaders]
  )

  return { isLoading, refetch, vitaleCards }
}
